export const OctoOperationsEnum = {
  Deposit: '0602',
  Payout: '0603',
};
